import React from 'react';
import { ReviewTemplateProps } from '../types';
import StarRating from '../../components/StarRating';
import { formatRecommendationDisplay, getRatingNumber } from '../../utils/formatters';
import { lightenColor } from '../../utils/colorUtils';
import SourceLogo from '../components/SourceLogo';

const ShareReviewTemplate5: React.FC<ReviewTemplateProps> = ({
    reviewerName,
    reviewText,
    rating,
    network,
    color = '#f97316',
    logo,
    showLogo,
    showSource,
}) => {
    const numericRating = getRatingNumber(rating);
    const isFacebookRecommendation =
        network === 'facebook' && (rating === 'positive' || rating === 'negative');

    const lightColor = lightenColor(color, 40);

    return (
        <div
            className="w-[1080px] h-[1080px] p-24 relative rounded-[20px] inline-flex flex-col justify-between items-start overflow-hidden"
            style={{ backgroundColor: color }}
        >
            <div className="z-[1000] m-auto rotate-180 left-[40px] top-[32px] absolute opacity-60">
                <svg
                    width="386"
                    height="320"
                    viewBox="0 0 194 160"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M133.71 81.0323C118.742 74.8387 109.452 61.4193 109.452 42.3225C109.452 17.0322 127.516 -5.73042e-06 150.742 -3.69996e-06C175.516 -1.53413e-06 193.064 17.5484 193.064 42.3226C193.064 54.1935 191 62.9677 181.71 86.7097L154.355 160L113.064 160L133.71 81.0323ZM24.2903 81.0322C9.32252 74.8387 0.0321894 61.4193 0.0321911 42.3225C0.0321933 17.0322 18.0967 -1.52962e-05 41.3225 -1.32657e-05C66.0967 -1.10999e-05 83.6451 17.5484 83.6451 42.3225C83.6451 54.1935 81.5806 62.9677 72.2903 86.7097L44.9354 160L3.64511 160L24.2903 81.0322Z"
                        fill={lightColor}
                    />
                </svg>
            </div>

            <div
                style={{
                    position: 'absolute',
                    width: '1080px',
                    height: '1080px',
                    left: '1196.23px',
                    top: '532.91px',
                    transform: 'rotate(50deg)',
                    transformOrigin: 'top left',
                    opacity: 0.6,
                    backgroundColor: lightColor,
                }}
            />

            <div className="self-stretch flex flex-col justify-start items-start gap-10 relative z-[1000]">
                {showSource && (
                    <div className={`inline-flex justify-start items-start gap-2.5`}>
                        <SourceLogo network={network} template="template1" />
                    </div>
                )}

                <div
                    className={`self-stretch text-left text-white text-[56px] font-semibold font-['Montserrat'] leading-[67.20px] ${!showSource && 'mt-[175px]'}`}
                >
                    {reviewText}
                </div>
            </div>

            <div className="flex items-end justify-between w-full">
                <div className="self-stretch flex flex-col justify-start items-start gap-5 relative z-10">
                    <div className="self-stretch text-left text-white text-[40px] font-semibold font-['Montserrat'] leading-[42px]">
                        {reviewerName}
                    </div>

                    {isFacebookRecommendation ? (
                        formatRecommendationDisplay(rating, 'template5')
                    ) : (
                        <StarRating
                            rating={numericRating}
                            iconSize={'h-[67px]'}
                            color={'#fff'}
                            classAdded={'ml-[-5px]'}
                        />
                    )}
                </div>

                {showLogo && logo && (
                    <div className="flex justify-center w-[240px] h-[75px] z-10 mb-[5px] absolute right-[60px]">
                        <img
                            src={logo}
                            alt="Logo"
                            className="w-auto h-full object-contain"
                            crossOrigin="anonymous"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShareReviewTemplate5;
